<template>
	<BaseContenedor>
		<BaseButton
			v-puede-disabled="[roles.Admistrador]"
			style-button="success"
			style-class="right floated"
			@click="descargarResultados"
		>
			<i class="download icon"></i>
			Resultados globales
		</BaseButton>
		<BaseButton
			v-puede-disabled="[roles.Admistrador]"
			style-button="secondary"
			style-class="right floated"
			@click="redirectToResultados"
		>
			<i class="tasks icon"></i>
			Resultados detallado
		</BaseButton>
		<br />
		<br />
		<br />

		<table class="ui table celled sortable compact">
			<thead>
				<tr>
					<th rowspan="2" class="boldFont greyColor four wide">
						<b class="boldFont greyColor">Ficha</b>
					</th>
					<th rowspan="2" class="boldFont greyColor six wide">
						<b class="boldFont greyColor">Nombre completo</b>
					</th>
					<th
						v-for="(area, index) in examen.areasDeConocimientos"
						:key="index"
						:colspan="area.secciones.length"
						style="text-align:center"
						class="boldFont greyColor six wide descending"
					>
						<b class="boldFont greyColor"
							>{{ area.clave }} - {{ area.nombre }}</b
						>
					</th>
					<th rowspan="2" class="boldFont greyColor four wide">
						<b class="boldFont greyColor">Total</b>
					</th>
				</tr>
				<tr>
					<template v-for="area in examen.areasDeConocimientos">
						<th
							v-for="seccion in area.secciones"
							:key="seccion.id"
							class="boldFont greyColor six wide descending"
							style="text-align:center"
						>
							<b class="boldFont greyColor"
								>{{ seccion.clave }} - {{ seccion.nombre }}</b
							>
						</th>
					</template>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(aspirante, index) in aspirantes" :key="index">
					<td>
						<router-link
							:to="
								`/examenes/aspirantes/${$route.params.clave}/${aspirante.ficha}`
							"
						>
							{{ aspirante.ficha }}
							<i class="icon linkify" style="font-size:.8em"></i>
						</router-link>
					</td>
					<td>{{ aspirante.nombreCompleto }}</td>
					<template v-for="area in examen.areasDeConocimientos">
						<td
							v-for="seccion in area.secciones"
							:key="seccion.id"
							class="greyColor six wide descending"
							style="text-align:center"
						>
							<b class="greyColor">{{
								getCalificacionSeccion(area, seccion, aspirante)
							}}</b>
						</td>
					</template>
					<th class="boldFont greyColor four wide">
						<b class="boldFont greyColor">{{
							getCalificacionAspirante(aspirante)
						}}</b>
					</th>
				</tr>
				<tr>
					<td colspan="2" style="text-align:right;"
						><b class="boldFont greyColor"> Totales (%)</b></td
					>
					<template v-for="area in examen.areasDeConocimientos">
						<td
							v-for="seccion in area.secciones"
							:key="seccion.id"
							class="greyColor six wide descending"
							style="text-align:center"
						>
							<b class="greyColor"
								>{{ getCalificacionSeccionGeneral(area, seccion) }}%</b
							>
						</td>
					</template>
					<td class="boldFont greyColor four wide">
						<b class="boldFont greyColor">{{ getCalificacionGeneral() }}%</b>
					</td>
				</tr>
			</tbody>
		</table>
	</BaseContenedor>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Rols from '@constants/roles';
export default {
	page: {
		title: 'Examen - Aspirantes',
		meta: [{ name: 'description', content: 'The examen aspirante page.' }]
	},
	data: function() {
		return {
			examen: {},
			paginaActual: 1,
			elemento: null,
			files: [],
			campos: {
				ficha: { nombre: 'Ficha', class: 'four wide' },
				nombreCompleto: { nombre: 'Nombre completo', class: 'six wide' },
				fechaYHoraInicio: { nombre: 'Fecha y hora inicio', class: 'six wide' }
			},
			filter: '',
			roles: Rols
		};
	},
	computed: {
		...mapGetters('examenAspirantes', [
			'getAspirantes',
			'getLoading',
			'getLoadingAction'
		]),
		...mapGetters('plantillas', ['getPlantillas']),
		plantilla: function() {
			return this.getPlantillas.CAT_EXAMEN_ASPIRANTES;
		},
		aspirantes: function() {
			return this.getAspirantes;
		}
	},
	watch: {
		filter: function(value) {
			this.$refs.table.ocultarElemento();
			if (this.paginaActual !== 1) this.paginaActual = 1;
		},
		getLoadingAction: function(value, old) {
			this.$confirm(null, value);
		}
	},
	mounted() {
		this.establecerUrlAtras(`/examenes/aspirantes/${this.$route.params.clave}`);
		if (this.$route.params.clave) {
			this.obtenerExamen({
				clave: this.$route.params.clave,
				onComplete: (response) => {
					this.obtenerExamenAspirantesResultados({
						clave: this.$route.params.clave
					});
					this.examen = response.data.data;
					this.establecerTitulo(`Aspirantes de ${this.examen.nombre}`);
				}
			});
		}
	},
	methods: {
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		...mapActions('examenes', ['obtenerExamen']),
		...mapActions('examenAspirantes', [
			'obtenerExamenAspirantesResultados',
			'descargarCSVResultadosGlobales'
		]),
		getCalificacionSeccion(area, seccion, aspiranteExamen) {
			return (
				this.getPreguntasCorrectasSeccion(area, seccion, aspiranteExamen) +
				' / ' +
				this.getTotalPreguntasSeccion(area, seccion, aspiranteExamen)
			);
		},
		getPreguntasCorrectasSeccion(area, seccion, aspiranteExamen) {
			return aspiranteExamen.areasDeConocimiento
				.find((x) => x.clave === area.clave)
				.secciones.find((x) => x.clave === seccion.clave).preguntasCorrectas;
		},
		getTotalPreguntasSeccion(area, seccion, aspiranteExamen) {
			return aspiranteExamen.areasDeConocimiento
				.find((x) => x.clave === area.clave)
				.secciones.find((x) => x.clave === seccion.clave).preguntas.length;
		},
		getCalificacionAspirante(aspiranteExamen) {
			return (
				this.getPreguntasCorrectasAspirante(aspiranteExamen) +
				' / ' +
				this.getTotalPreguntasAspirante(aspiranteExamen)
			);
		},
		getPreguntasCorrectasAspirante(aspiranteExamen) {
			return aspiranteExamen.areasDeConocimiento
				.map((x) => x.preguntasCorrectas)
				.reduce((a, b) => a + b, 0);
		},
		getTotalPreguntasAspirante(aspiranteExamen) {
			return aspiranteExamen.areasDeConocimiento
				.map((x) => x.totalPreguntas)
				.reduce((a, b) => a + b, 0);
		},
		getCalificacionSeccionGeneral(area, seccion, aspiranteExamen) {
			return (
				(100 /
					this.getAspirantes
						.map((x) => this.getTotalPreguntasSeccion(area, seccion, x))
						.reduce((a, b) => a + b, 0)) *
				this.getAspirantes
					.map((x) => this.getPreguntasCorrectasSeccion(area, seccion, x))
					.reduce((a, b) => a + b, 0)
			).toFixed(2);
		},
		getCalificacionGeneral() {
			return (
				(100 /
					this.getAspirantes
						.map((x) => this.getTotalPreguntasAspirante(x))
						.reduce((a, b) => a + b, 0)) *
				this.getAspirantes
					.map((x) => this.getPreguntasCorrectasAspirante(x))
					.reduce((a, b) => a + b, 0)
			).toFixed(2);
		},
		descargarResultados() {
			this.descargarCSVResultadosGlobales({
				clave: this.examen.clave,
				onComplete: (response) => {
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(response.data);
					link.download = `resultados_globales_examen_${this.examen.clave}.csv`;
					link.click();
				}
			});
		},
		redirectToResultados() {
			this.$router.push(
				`/examenes/detalleresultados/${this.$route.params.clave}`
			);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
</style>
